import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environmentMIQ } from '../environment-miq';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    constructor(titleService: Title) {
        let title = 'Maintenance IQ';
        if (environmentMIQ.titleAddition) {
            title += environmentMIQ.titleAddition;
        }
        titleService.setTitle(title);
    }
}
